export { default } from "./PageContainer.styled";
